/* Suggested path: frontend/src/data/configs/index.js
   ------------------------------------------------------
   This is Task 2 from the original KIMI_HANDOFF_INSTRUCTIONS.md
   (May 15) — it never got built, which is part of why Dashboard.jsx
   and Skills.jsx still had their own hardcoded duplicate cards when
   this reconciliation started.

   Keyed by `card_shape` (matching the Supabase column) rather than
   skill id: any future skill row with card_shape:'terminal' reuses
   AiPromptingCard's renderer automatically, without a code change.
   The coming-soon translator-terminal shape isn't in here — it's a
   different card TYPE (vote-solicitation, not progress-tracking) and
   lives in components/TranslatorSkillCard.jsx instead, shared by
   Dashboard.jsx and Skills.jsx. The book shape no longer exists —
   Precision Storytelling shipped as a live skill, so BookSkillCard
   was deleted outright.
*/
import AiPromptingCard from './config.ai-prompting.jsx';
import SalesNegotiationCard from './config.sales-negotiation.jsx';
import CopywritingCard from './config.copywriting.jsx';
import PrecisionStorytellingCard from './config.precision-storytelling.jsx';

export const SKILL_CARD_REGISTRY = {
  terminal: AiPromptingCard,
  contract: SalesNegotiationCard,
  pencil: CopywritingCard,
  cloud: PrecisionStorytellingCard,
};

/**
 * getSkillCard(cardShape)
 * Returns the Card component for a given card_shape, or null if this
 * shape doesn't have a progress-card renderer (e.g. coming-soon shapes).
 */
export const getSkillCard = (cardShape) => SKILL_CARD_REGISTRY[cardShape] ?? null;
